import styled from 'styled-components';

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: var(--allie-spacing-3xl) var(--allie-spacing-xl);
  background: none;
  text-align: center;
  gap: var(--allie-spacing-3xl);
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--allie-spacing-xl);
  background: var(--allie-color-white);
  border-radius: var(--allie-radius-full);
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 320px;
`;
